export default "__VITE_ASSET__c5ea94e4__"